import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Stack
} from '@mui/material';
import { PayrollRejectRequest } from '../../services/payrollService';

interface RejectDialogProps {
  open: boolean;
  onClose: () => void;
  onReject: () => void;
  loading: boolean;
  rejectForm: PayrollRejectRequest;
  onFormChange: (form: PayrollRejectRequest) => void;
}

const RejectDialog: React.FC<RejectDialogProps> = ({
  open,
  onClose,
  onReject,
  loading,
  rejectForm,
  onFormChange
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Reject Payroll</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              label="Rejection Reason"
              value={rejectForm.rejectionReason}
              onChange={(e) => onFormChange({ ...rejectForm, rejectionReason: e.target.value })}
              required
            />
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Additional Notes (optional)"
              value={rejectForm.rejectionNotes}
              onChange={(e) => onFormChange({ ...rejectForm, rejectionNotes: e.target.value })}
            />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={onReject} 
          variant="contained" 
          color="error" 
          disabled={loading || !rejectForm.rejectionReason}
        >
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectDialog;
